import { Injectable } from '@angular/core';

export enum Todo {
  ADD_CONNECTION,
  CHOOSE_TEAMS,
  SYNC_EMPLOYEES,
  SET_PRODUCT_ALLOWANCES,
  SET_PRODUCTS
}

export interface TodoItem {
  todo: Todo;
  icon: string;
  title: string;
  description: string;
  done: boolean;
  active: boolean;
  page: string;
  downstream: Array<Todo>;  // items enabled when this one is set to done
}

@Injectable({
  providedIn: 'root'
})
export class TodoService {

  static items: Array<TodoItem> = [
    {
      todo: Todo.ADD_CONNECTION,
      icon: 'domain',
      title: 'Reminder 1',
      description: 'Add your connection to UKG Ready',
      done: false,
      active: true,
      page: 'payrolladmin/company/connections',
      downstream: [Todo.CHOOSE_TEAMS, Todo.SET_PRODUCTS]
    },
    {
      todo: Todo.CHOOSE_TEAMS,
      icon: 'groups',
      title: 'Reminder 2',
      description: 'Choose how to group your employees',
      done: false,
      active: false,
      page: '',
      downstream: [Todo.SYNC_EMPLOYEES, Todo.SET_PRODUCTS]
    },
    {
      todo: Todo.SYNC_EMPLOYEES,
      icon: 'person_search',
      title: 'Reminder 3',
      description: 'Get employee census from UKG Ready',
      done: false,
      active: false,
      page: '',
      downstream: [Todo.SET_PRODUCT_ALLOWANCES, Todo.SET_PRODUCTS]
    },
    {
      todo: Todo.SET_PRODUCT_ALLOWANCES,
      icon: 'attach_money',
      title: 'Reminder 4',
      description: 'Set employee product purchase allowances',
      done: false,
      active: false,
      page: '',
      downstream: [Todo.SET_PRODUCTS]
    },
    {
      todo: Todo.SET_PRODUCTS,
      icon: 'policy',
      title: 'Reminder 5',
      description: 'Choose products to enroll in',
      done: false,
      active: false,
      page: '',
      downstream: []
    },
  ];

  constructor() {
  }

  getPendingItems(): Array<TodoItem> {
    return TodoService.items.filter(item => item.active && !item.done);
  }

  setItemState(todo: Todo, done: boolean): void {
    const foundItem = TodoService.items.find(item => item.todo === todo);
    if (foundItem) {
      foundItem.done = done;
      if (done) {
        foundItem.downstream.forEach(item => {
          const thisItem = TodoService.items.find(item2 => item2.todo === todo);
          if (thisItem) {
            thisItem.active = true;
          }
        });
      }
    }
  }
}
